import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownAddressesChange } from '../../api';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import { transformAddresses } from '../../../common/lib/formValuesHelpers';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';
import AddressesField from '../../../createNew/common/AddressesField/AddressesField';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => {
    dispatch({ type: modalActionTypes.resetModalData });
    form.resetFields();
  };

  const { change, loading } = useShutdownAddressesChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = transformAddresses(formValues[fieldNames.addresses], true);
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  const { addressIds = [], houseIds = [] } = shutdown?.alertAddresses || {};
  const hasInitValue = [
    [shutdown?.serviceCompany?.id],
    houseIds,
    addressIds,
  ].some((item) => Boolean(item.length));

  return (
    <Modal
      visible={type === modalTypes.changeShutdownAddresses}
      onCancel={close}
      onOk={handleSubmit}
      title={`${hasInitValue ? 'Изменить' : 'Добавить'} адреса`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.owner}
        alertType="sfsd"
      />
      {!!shutdown?.flatCount && (
        <span
          style={{ fontWeight: 700, fontSize: 14, color: '#888888' }}
        >{`Количество помещений: ${shutdown?.flatCount}`}</span>
      )}
      <Form colon={false}>
        <AddressesField
          form={form}
          initialValue={shutdown}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_addresses' })(
  ModalContainer
);

export default ChangeModal;
